import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ContactInfoFragment,
    GetContactInfo as GetContactInfoQuery,
} from 'nutshell-graphql-types';

import GET_CONTACT_INFO from './graphql/queries/get-contact-info.graphql';

export const useGetContactInfo = (
    contactId: string
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    contactInfo: ContactInfoFragment | null | undefined;
} => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetContactInfoQuery, Record<any, any>>(GET_CONTACT_INFO, {
        variables: {id: contactId},
    });

    return {
        contactInfo: data && data.contact ? data.contact : undefined,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
